import { render, staticRenderFns } from "./Instructors.vue?vue&type=template&id=06b80524"
import script from "./Instructors.vue?vue&type=script&lang=ts"
export * from "./Instructors.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports